import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tt-logo',
    templateUrl: './tmv-logo.svg',
    styleUrls: ['./logo.component.scss'],
    standalone: true
})
export class LogoComponent {
  constructor() { }

}
